var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatePickCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.763,
    height: 17.664,
    viewBox: "0 0 16.763 17.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calendar_month_FILL0_wght400_GRAD0_opsz48",
    d: "M21.366,21.664a1.376,1.376,0,0,0,.978-.4,1.24,1.24,0,0,0,.419-.927V6.65a1.24,1.24,0,0,0-.419-.927,1.376,1.376,0,0,0-.978-.4H19.853V4H18.339V5.325H10.423V4H8.91V5.325H7.4a1.376,1.376,0,0,0-.978.4A1.24,1.24,0,0,0,6,6.65V20.34a1.24,1.24,0,0,0,.419.927,1.376,1.376,0,0,0,.978.4Zm0-1.325H7.4V10.845H21.366Zm0-10.819H7.4V6.65H21.366Zm0,0v0ZM14.381,14.6a.927.927,0,0,0,.664-.254.873.873,0,0,0,0-1.259.994.994,0,0,0-1.327,0,.873.873,0,0,0,0,1.259A.927.927,0,0,0,14.381,14.6Zm3.725,0a.927.927,0,0,0,.664-.254.873.873,0,0,0,0-1.259.994.994,0,0,0-1.327,0,.873.873,0,0,0,0,1.259A.927.927,0,0,0,18.106,14.6Zm-7.45,0a.927.927,0,0,0,.664-.254.873.873,0,0,0,0-1.259.994.994,0,0,0-1.327,0,.873.873,0,0,0,0,1.259A.927.927,0,0,0,10.656,14.6Zm3.725,3.533a.927.927,0,0,0,.664-.254.873.873,0,0,0,0-1.259.994.994,0,0,0-1.327,0,.873.873,0,0,0,0,1.259A.927.927,0,0,0,14.381,18.131Zm3.725,0a.927.927,0,0,0,.664-.254.873.873,0,0,0,0-1.259.994.994,0,0,0-1.327,0,.873.873,0,0,0,0,1.259A.927.927,0,0,0,18.106,18.131Zm-7.45,0a.927.927,0,0,0,.664-.254.873.873,0,0,0,0-1.259.994.994,0,0,0-1.327,0,.873.873,0,0,0,0,1.259A.927.927,0,0,0,10.656,18.131Z",
    transform: "translate(-6 -4)",
    fill: "#5b5b5b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePickCalendar);
export default __webpack_public_path__ + "static/media/DatePick_calendar.70e817f71993520a1ae7551428572eb6.svg";
export { ForwardRef as ReactComponent };